import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faHome } from '@fortawesome/free-solid-svg-icons';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/dashboard');
    };

    return (
        <Container fluid className="vh-100 d-flex align-items-center justify-content-center">
            <Row className="w-100 justify-content-center">
                <Col xs={12} className="text-center">
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        size="4x"
                        className="text-warning mb-4"
                    />
                    <h1 className="display-1 fw-bold text-muted">404</h1>
                    <h2 className="mb-3">Page Not Found</h2>
                    <p className="text-muted mb-4">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                    <Button variant="primary" size="lg" onClick={handleGoHome}>
                        <FontAwesomeIcon icon={faHome} className="me-2" />
                        Go to Dashboard
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default NotFoundPage;
